/**
 * Global site state.
 *
 */

import { AxiosError } from 'axios';
import { VuexModule, Action, Mutation, Module, getModule } from 'vuex-module-decorators';
import { UNAUTHORIZED, FORBIDDEN, NOT_FOUND } from 'http-status-codes';
import menuModule from './menu/index';
import store from '@/store';
import userModule from './user';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { MenuItems } from '@/types/menuItem';

@Module({ dynamic: true, store, name: 'site', namespaced: true })
class SiteModule extends VuexModule {
    errors: string[] = [];
    isGlobalError = false;
    isBlock = false;
    menuItems: MenuItems = {};

    @Mutation
    setMenuItems(items: MenuItems) {
        this.menuItems = items;
    }

    @Mutation
    clearMenu() {
        this.menuItems = {};
    }

    @Mutation
    addError(error: string) {
        this.errors.push(error);
    }

    @Mutation
    setGlobalError(isGlobalError: boolean) {
        this.isGlobalError = isGlobalError;
    }

    @Mutation
    SET_IS_BLOCK(bool: boolean) {
        this.isBlock = bool;
    }

    @Action
    setIsBlock(bool: boolean) {
        this.context.commit('SET_IS_BLOCK', bool);
    }

    @Action
    fetchApiResponseError(error: AxiosError) {
        switch (error.response?.status) {
            case NOT_FOUND: {
                this.setGlobalError(true);
                const errorMessage = error.response?.data.message ?? 'Not Found';
                this.context.commit('addError', errorMessage);
                
                ResponseHandlerModule.scheduleRedirectToNotFound();

                return
            }
            case FORBIDDEN: {
                const errorMessage = 'Ошибка доступа';

                ResponseHandlerModule.showNotify({ message: errorMessage, type: 'fail' });
                this.context.commit('addError', errorMessage);

                return
            }
            case UNAUTHORIZED: {
                const errorMessage = 'Ошибка доступа';

                this.setGlobalError(true);
                ResponseHandlerModule.showNotify({ message: errorMessage, type: 'fail' });
                this.context.commit('addError', errorMessage);

                userModule.removeToken();
                return;
            }
            default: {
                const errorMessage = error.response?.data.message ?? 'Упс... Неизвестная ошибка на сервере'
                this.context.commit('addError', errorMessage);
            }
        }
    }

    @Action
    fetchApiRequestError(error: AxiosError) {
        this.context.commit('addError', error.response?.data.message ?? 'Упс... Неизвестная сетевая ошибка');
    }

    @Action
    async init() {
        await menuModule.initMenuItems();
        this.setMenuItems(menuModule.menuItems);
    }
}

export default getModule(SiteModule);
